import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CouponError, CouponResponse, COUPON_ERROR } from 'src/app/domains/payment/models/payment.model';
import { PaymentService } from 'src/app/domains/payment/services/payment.service';

@Component({
  selector: 'gdp-coupon-form',
  templateUrl: './coupon-form.component.html',
  styleUrls: ['./coupon-form.component.scss']
})
export class CouponFormComponent implements OnInit {
  @Input() coupon: string = null;
  @Input() chargebeeAccount: string;
  @Input() couponExist: boolean = false;
  public form: UntypedFormGroup;
  public showDiscountInput = false;
  public loading: boolean = false;
  public error: boolean = false;
  public errorExpired: boolean = false;
  private valueSubsctiption: Subscription;

  @Output() couponChange: EventEmitter<CouponResponse> = new EventEmitter();
  @Output() couponError: EventEmitter<CouponError> = new EventEmitter();

  constructor(
    private fb: UntypedFormBuilder,
    private paymentService: PaymentService
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      code: new UntypedFormControl('', [Validators.required])
    });
    if (this.coupon) {
      this.form.controls.code.setValue(this.coupon);
      this.showDiscountInput = true;
      this.checkDiscount();
    }
    this.valueSubsctiption = this.form.valueChanges.subscribe(() => {
      this.error = false;
      this.errorExpired = false;
    }
    );
  }

  ngOnDestroy() {
    this.valueSubsctiption.unsubscribe();
  }

  get canCheckDiscount() {
    return this.form.dirty && this.form.valid;
  }

  clearInput(): void {
    this.form.controls.code.setValue(null);
  }

  checkDiscount() {
    this.loading = true;
    this.paymentService.getCouponInfo(this.form.value.code, this.chargebeeAccount)
      .subscribe(
        (c: CouponResponse) => {
          if (c.status === 'active') {
            this.loading = false;
            this.showDiscountInput = false;
            this.couponExist = true;
            this.couponChange.emit(c);
          } else {
            if (c.status === 'expired') {
              this.errorExpired = true;
              this.onCouponError(COUPON_ERROR.EXPIRED, c);
            }
          }
        }, (err: HttpErrorResponse) => {
          if (err.status === 400) {
            this.onCouponError(COUPON_ERROR.NOT_FOUND, err);
          } else {
            this.onCouponError(COUPON_ERROR.API_ERROR, err);
          }
        });
  }

  private onCouponError(errorType: COUPON_ERROR, data: HttpErrorResponse | CouponResponse) {
    this.error = true;
    this.loading = false;
    this.couponError.emit({ data: data, type: errorType });
  }
}